<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerSIPChannels">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { SIPChannelService } from "../../../services/SIPChannelService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "SIPChannelPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sIPChannel: null,
      sIPChannelService: new SIPChannelService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerSIPChannels() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.sIPChannel) {
        return {
          title: this.sIPChannel.value,
          id: this.ids[0],
          status: this.getStatus(this.sIPChannel.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.sIPChannel) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.sIPChannel.code,
            },
          ],
          [
            {
              title: this.$t("sIPChannelValue"),
              text: this.sIPChannel.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.sIPChannel) {
        return [
        [
            {
              title: this.$t("createdByTxt"),
              text: this.sIPChannel.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.sIPChannel.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.sIPChannel.createdAt)  + ' ' + getAMorPM(this.sIPChannel.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.sIPChannel.lastUpdated)  + ' ' + getAMorPM(this.sIPChannel.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getSIPChannel();
      } catch (e) {
        this.hasError = true;
      }
    },
    getSIPChannel() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.sIPChannelService.get(this.ids[0]).then((res) => {
          this.sIPChannel = res.data;
          this.loading = false;
        });
      }
      this.sIPChannel = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.sIPChannel);
    },
    deletePanel() {
      this.$emit("delete", this.sIPChannel);
    },
    showHistoryPanel() {
      this.$emit("history", this.sIPChannel);
    },
  },
};
</script>

<style scoped></style>
